import React from 'react'
import { useSelector } from 'react-redux'
import { hasAnyRole } from '../../redux/reducers'

// Counterpart of HideForRoles: only renders the children if the current user
// has one of the given project roles, or is a platform admin / tenant admin
// (if `platformAdmin` / `tenantAdmin` is set)
function ShowForRoles({
  roles = [],
  platformAdmin = false,
  tenantAdmin = false,
  children,
}) {
  const allowed = useSelector((state) =>
    hasAnyRole(state, { roles, platformAdmin, tenantAdmin })
  )

  if (allowed) {
    return <>{children}</>
  } else {
    return null
  }
}

export default ShowForRoles
